export default {
  zh: {
    totalConisText:'Total Coins',
    goldTip:"- You friend will receive a gift by using this code when finished register.",
    initCodeText:"Gift Code",
    applyText:"Share with Friends",
    listTitle:"Invited Users",
    link: 'Come join me at App. ',
    copylinkText:"Copy Link",
    whatappText:"WhatsApp",
    goldTopTip:"- The invite will be completed when your freind use this gift code.",
    entpla:"Enter the Gift Code",
    redeem:'Redeem',
    yes: "confirm",
    no: "cancel",
    redeemOk:"Redemption successful",
    okText:"OK",
    failText:"Gift code redemption failed",
    hadRedeem:"Gift code has been redeemed",
    plseEntText:"Please enter gift code",
    connotUseCode:"You can't use this gift code",
  },
  en: {
    totalConisText:'Total Coins',
    goldTip:"- You friend will receive a gift by using this code when finished register.",
    initCodeText:"Gift Code",
    applyText:"Share with Friends",
    listTitle:"Invited Users",
    link: 'Come join me at App. ',
    copylinkText:"Copy Link",
    whatappText:"WhatsApp",
    goldTopTip:"- The invite will be completed when your freind use this gift code.",
    entpla:"Enter the Gift Code",
    redeem:'Redeem',
    yes: "confirm",
    no: "cancel",
    redeemOk:"Redemption successful",
    okText:"OK",
    failText:"Gift code redemption failed",
    hadRedeem:"Gift code has been redeemed",
    plseEntText:"Please enter gift code",
    connotUseCode:"You can't use this gift code",
  },
  ar: { // 阿拉伯
    totalConisText:'اجمالي الكوينزات',
    goldTip:"- تكتمل الدعوة عندما يستخدم صديقك كود الهدية اثناء تسجيل الحساب.",
    initCodeText:"كود الهدية",
    applyText:"مشاركة مع صديق",
    listTitle:"دعوة صديق",
    link: 'تعال وانضم لي',
    copylinkText:"انسخ الرابط",
    whatappText:"واتساب",
    goldTopTip:"- سيحصل صديقك على هدية عند استخدامه هذا الكود اثناء التسجيل.",
    entpla:"ادخل كود الهدية",
    redeem:'إستلام',
    yes: "أكد",
    no: "إلغاء",
    redeemOk:"تم الإستبدال بنجاح",
    okText:"OK",
    failText:"فشل إستلام الهدية",
    hadRedeem:"تم إستلام الهدية بنجاح",
    plseEntText:"ادخل كود الهدية",
    connotUseCode:"كود الهدية غير صالح",
  },
  tr:{ //土耳其
    totalConisText:'Toplam Coins',
    goldTip:"- Arkadaşınız kayıt işlemi tamamlandığında bu kodu kullanarak bir hediye alacaktır.",
    initCodeText:"Davet Kodu",
    applyText:"Arkadaşlarınla ​​Paylaş",
    listTitle:"Davet Edilen Kullanıcılar",
    link: 'Come join me at App. ',
    copylinkText:"Link Kopyala",
    whatappText:"WhatsApp",
    goldTopTip:"- Arkadaşınız bu hediye kodunu kullandığında davet tamamlanır.",
    entpla:"Davet Kodunu Girin",
    redeem:'Gönder',
    yes: "onaylamak",
    no: "iptal etmek",
    redeemOk:"Redemption successful",
    okText:"TAMAM",
    failText:"Hediye kodunun kullanımı başarısız oldu",
    hadRedeem:"Hediye kodu kullanıldı",
    plseEntText:"Lütfen hediye kodunu girin",
    connotUseCode:"Bu hediye kodunu kullanamazsınız",
  },
  pt:{
    totalConisText: 'Total de Moedas',
    goldTip: "- Seu amigo receberá um presente ao usar este código após completar o registro.",
    initCodeText: "Código de Presente",
    applyText: "Compartilhar com Amigos",
    listTitle: "Usuários Convidados",
    link: 'Venha se juntar a mim no App.',
    copylinkText: "Copiar Link",
    whatappText: "WhatsApp",
    goldTopTip: "- O convite será concluído quando seu amigo usar este código de presente.",
    entpla: "Digite o Código de Presente",
    redeem: 'Resgatar',
    yes: "confirmar",
    no: "cancelar",
    redeemOk: "Resgate bem-sucedido",
    okText: "OK",
    failText: "Falha no resgate do código de presente",
    hadRedeem: "Código de presente já foi resgatado",
    plseEntText: "Por favor, insira o código de presente",
    connotUseCode: "Você não pode usar este código de presente",

  },
  id:{
    totalConisText: 'Total Koin',
    goldTip: "- Teman Anda akan menerima hadiah dengan menggunakan kode ini setelah selesai mendaftar.",
    initCodeText: "Kode Hadiah",
    applyText: "Bagikan dengan Teman",
    listTitle: "Pengguna yang Diundang",
    link: 'Ayo bergabung dengan saya di Aplikasi.',
    copylinkText: "Salin Tautan",
    whatappText: "WhatsApp",
    goldTopTip: "- Undangan akan selesai ketika teman Anda menggunakan kode hadiah ini.",
    entpla: "Masukkan Kode Hadiah",
    redeem: 'Tebus',
    yes: "konfirmasi",
    no: "batal",
    redeemOk: "Tebusan berhasil",
    okText: "OK",
    failText: "Tebusan kode hadiah gagal",
    hadRedeem: "Kode hadiah sudah ditebus",
    plseEntText: "Silakan masukkan kode hadiah",
    connotUseCode: "Anda tidak dapat menggunakan kode hadiah ini",

  },
  uz: {
        "totalConisText": "Jami Tangalar",
        "goldTip": "- Do'stingiz ro'yxatdan o'tishni tugatgandan so'ng, bu kodni ishlatganingizda sovg'a oladi.",
        "initCodeText": "Sovg'a Kodi",
        "applyText": "Do'stlar bilan ulashish",
        "listTitle": "Taklif qilingan Foydalanuvchilar",
        "link": "Keling, menga App'ga qo'shiling.",
        "copylinkText": "Havolani nusxalash",
        "whatappText": "WhatsApp",
        "goldTopTip": "- Taklif, do'stingiz bu sovg'a kodini ishlatganda yakunlanadi.",
        "entpla": "Sovg'a Kodini kiriting",
        "redeem": "Qaytarish",
        "yes": "tasdiqlash",
        "no": "bekor qilish",
        "redeemOk": "Qaytarish muvaffaqiyatli",
        "okText": "OK",
        "failText": "Sovg'a kodi bilan qaytarish muvaffaqiyatsiz",
        "hadRedeem": "Sovg'a kodi allaqachon qaytarilgan",
        "plseEntText": "Iltimos, sovg'a kodini kiriting",
        "connotUseCode": "Siz bu sovg'a kodini ishlata olmaysiz"
    },
    ru: {
        "totalConisText": "Общее количество монет",
        "goldTip": "- Ваш друг получит подарок, используя этот код после завершения регистрации.",
        "initCodeText": "Код подарка",
        "applyText": "Поделиться с друзьями",
        "listTitle": "Приглашенные пользователи",
        "link": "Присоединяйтесь ко мне в App.",
        "copylinkText": "Копировать ссылку",
        "whatappText": "WhatsApp",
        "goldTopTip": "- Приглашение будет завершено, когда ваш друг использует этот код подарка.",
        "entpla": "Введите код подарка",
        "redeem": "Обменять",
        "yes": "подтвердить",
        "no": "отменить",
        "redeemOk": "Обмен успешен",
        "okText": "OK",
        "failText": "Ошибка обмена кода подарка",
        "hadRedeem": "Код подарка уже был обменян",
        "plseEntText": "Пожалуйста, введите код подарка",
        "connotUseCode": "Вы не можете использовать этот код подарка"
    },
    fa: {
        "totalConisText": "تعداد کل سکه ها",
        "goldTip": "- دوست شما پس از اتمام ثبت نام با استفاده از این کد، هدیه دریافت خواهد کرد.",
        "initCodeText": "کد هدیه",
        "applyText": "با دوستان به اشتراک بگذارید",
        "listTitle": "کاربران دعوت شده",
        "link": "بیایید به من در برنامه بپیوندید.",
        "copylinkText": "کپی لینک",
        "whatappText": "WhatsApp",
        "goldTopTip": "- دعوت وقتی تکمیل می‌شود که دوست شما از این کد هدیه استفاده کند.",
        "entpla": "کد هدیه را وارد کنید",
        "redeem": "تعویض",
        "yes": "تایید",
        "no": "لغو",
        "redeemOk": "تعویض موفقیت‌آمیز",
        "okText": "تایید",
        "failText": "تعویض کد هدیه ناموفق بود",
        "hadRedeem": "کد هدیه قبلاً تعویض شده است",
        "plseEntText": "لطفاً کد هدیه را وارد کنید",
        "connotUseCode": "شما نمی‌توانید از این کد هدیه استفاده کنید"
    }

}


// WEBPACK FOOTER //
// src/pages/app/giftcodeview/lang.js